import { NoticesComponentModule } from '@b2b/common/components/notices';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { BasePriceFilterModule } from '@b2b/common/filters';
import { ThemesData } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ACMEResponse, ColumnDef, ContentHeaderProps, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';
import { CurrentPrice, CurrentPriceList } from '../types';
import { PriceListsCreateModalControllerModule } from './PriceListsCreateModalController';
import { PriceListsDuplicateModalControllerModule } from './PriceListsDuplicateModalController';
import { PriceListsRemoveModalControllerModule } from './PriceListsRemoveModalController';
import { PricingListsEditControllerModule } from './PricingListsEditController';

PricingListsController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  'HelpersService',
  'ApiService',
  'CalendarService',
  'TemplatesService',
  'NoticeFactory',
  'ThemesHelperService',
  'ThemesData',
];

function PricingListsController(
  $scope: IScope & { pricingLists: TODO },
  $state: StateService,
  $uibModal: UIBModalService,
  $timeout: ITimeoutService,
  HelpersService: TODO,
  ApiService: ApiService,
  CalendarService: CalendarService,
  TemplatesService: TODO,
  NoticeFactory: NoticeFactory,
  ThemesHelperService: ThemesHelperService,
  ThemesData: { data: ACMEResponse<ThemesData> }
) {
  const ctrl = {
    isEditing: false,
    isRemoving: false,
    isUpdating: false,
    isLoaded: false,
    isSorting: false,

    notice: new NoticeFactory(),
    currentPriceListIndex: 0,
    currentPriceIndex: 0,
    selectedPriceListId: 0,
    currentPrice: {
      personType: {
        name: '',
        description: '',
        active: true,
        type: 'Individual',
        displayOrder: 0,
        defaultPrice: '10.5',
      },
      salesChannels: [],
      price: '1.02',
      basePrice: null,
      primePrice: '1.03',
    } as CurrentPrice,

    tmpCurrentPriceList: {} as TODO,

    currentPriceList: {
      name: '',
      description: '',
      effectiveStartTime: CalendarService.toISO8601(new Date()),
      effectiveEndTime: null,
      priceListType: null,
      prices: [],
    } as CurrentPriceList,

    salesChannels: [
      {
        channel: 'online',
        name: 'Online',
        enabled: true,
      },
      {
        channel: 'pointOfSale',
        name: 'Point of Sale',
        enabled: true,
      },
      {
        channel: 'reseller',
        name: 'Reseller',
        enabled: true,
      },
      {
        channel: 'customerRep',
        name: 'Customer Rep.',
        enabled: true,
      },
      {
        channel: 'kiosk',
        name: 'Kiosk',
        enabled: true,
      },
    ],

    columns: [
      {
        field: 'orderAction',
        width: '50',
        displayName: 'Action',
        cellTemplate: `<div class="ui-grid-cell-contents text-center pricing-lists-action"><a data-ng-click="grid.appScope.moveUp(row)"><span title="Move Up" role="presentation" class="fa fa-2x fa-caret-up"></span></a><a data-ng-click="grid.appScope.moveDown(row)"><span role="presentation" title="Move Down" class="fa fa-2x fa-caret-down"></span></a></div>`,
        visible: false,
      },
      {
        field: 'displayOrder',
        width: '65',
        displayName: 'Listing',
        enableCellEdit: true,
        enableCellEditOnFocus: true,
        cellTemplate: '<div class="ui-grid-cell-contents text-center" ng-class="col.colIndex()">{{ COL_FIELD }}</div>',
        visible: false,
      },
      {
        field: 'personType.name',
        displayName: 'Ticket Category',
      },
      {
        field: 'personType.description',
        displayName: 'Description',
        editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
        enableCellEdit: true,
        enableCellEditOnFocus: true,
        cellEditableCondition: () => ctrl.isEditing === true,
      },
      {
        field: 'price',
        displayName: 'Price',
        cellFilter: 'currency',
        editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
        enableCellEdit: true,
        enableCellEditOnFocus: true,
        cellEditableCondition: () => ctrl.isEditing === true,
      },
      {
        field: 'salesChannels[0].enabled',
        displayName: 'Web',
        cellEditableCondition: () => ctrl.isEditing === true,
        cellTemplate: createSaleChannelColumnTemplate(),
      },
      {
        field: 'salesChannels[1].enabled',
        displayName: 'POS',
        cellEditableCondition: () => ctrl.isEditing === true,
        cellTemplate: createSaleChannelColumnTemplate(),
      },
      {
        field: 'salesChannels[2].enabled',
        displayName: 'Reseller',
        cellEditableCondition: () => ctrl.isEditing === true,
        cellTemplate: createSaleChannelColumnTemplate(),
      },
      {
        field: 'salesChannels[3].enabled',
        displayName: 'Customer Rep.',
        cellEditableCondition: () => ctrl.isEditing === true,
        cellTemplate: createSaleChannelColumnTemplate(),
      },
      {
        field: 'salesChannels[4].enabled',
        displayName: 'Kiosk',
        cellEditableCondition: () => ctrl.isEditing === true,
        cellTemplate: createSaleChannelColumnTemplate(),
      },
    ] as ColumnDef[],

    duplicatePriceList: {},

    model: [],

    pricingListsGrid: {
      enableRowSelection: false,
      showFooter: true,
      paginate: true,
      pageSize: 50,
      multiSelect: false,
      appScopeProvider: {
        isEditing: () => ctrl.isEditing,
        removePrice: (row) => {
          ctrl.removePrice(row);
        },
        onCellEdit: (item, col, newValue, oldValue) => {
          ctrl.onDisplayOrderChanged(item, col, newValue, oldValue);
        },
        moveUp: (row) => {
          ctrl.moveUp(row);
        },
        moveDown: (row) => {
          ctrl.moveDown(row);
        },
      },
    },

    enableSalesTax: false,

    init: function () {
      if (ThemesData && ThemesData.data.success) {
        ThemesHelperService.setModel(ThemesData.data.payload);

        ctrl.enableSalesTax = ThemesHelperService.getFeatureFlag('enableSalesTax');

        if (ctrl.enableSalesTax) {
          const priceColumnIndex = ctrl.columns.findIndex((column) => column.field === 'price');

          /**
           * Insert after `basePrice` after `price` column
           */
          ctrl.columns.splice(priceColumnIndex + 1, 0, {
            field: 'basePrice',
            displayName: 'Base Price',
            cellFilter: 'basePrice',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true,
            enableCellEditOnFocus: true,
            cellEditableCondition: () => ctrl.isEditing === true,
          });
        }
      }

      $scope.$emit('Application::contentTitleChange', {
        title: 'Pricing',
        buttonRight: {
          label: 'Create Price List',
          permissions: ['PRICE_LISTS_CREATE'],
          action: () => {
            ctrl.create();
          },
        },
      } satisfies ContentHeaderProps);

      $scope.$on('PricingSidebarController::selectList', ctrl.onSelectList);
      $scope.$on('PricingListsEditController::addPrice', ctrl.onAddPrice);
      $scope.$on('uiGridEventChangeOrder', ctrl.onGridEventChangeOrder);

      if ($state.params && $state.params.id) {
        ctrl.selectedPriceListId = $state.params.id;
      }

      ctrl.getPriceLists();
    },

    toggleEdit: function (restore) {
      ctrl.isEditing = !ctrl.isEditing;

      if (ctrl.isEditing) {
        ctrl.tmpCurrentPriceList = angular.copy(ctrl.currentPriceList);

        ctrl.columns.push({
          field: 'remove',
          displayName: 'Actions',
          enableHiding: false,
          enableSorting: false,
          onCellNavClick: function (row, col) {
            ctrl.pricingListsGrid.appScopeProvider.removePrice(row);
          },
          cellTemplate: `<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.removePrice(row)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>`,
        });
      } else {
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.hideErrorMessages();

        ctrl.columns.pop();

        if (restore) {
          ctrl.currentPriceList = angular.copy(ctrl.tmpCurrentPriceList);
        }
      }
    },

    toggleReorder: function (restore) {
      ctrl.isSorting = !ctrl.isSorting;
      ctrl.columns[0].visible = ctrl.isSorting;
      ctrl.columns[1].visible = ctrl.isSorting;
      $scope.$broadcast('DataGrid::DataChange', { type: 'COLUMN' });

      if (ctrl.isSorting) {
        ctrl.tmpCurrentPriceList = angular.copy(ctrl.currentPriceList);
      } else {
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.hideErrorMessages();

        if (restore) {
          ctrl.currentPriceList = ctrl.tmpCurrentPriceList;
        }
      }
    },

    copy: function () {
      $uibModal
        .open<string>({
          templateUrl: 'views/application/views/pricing/lists/modals/duplicatePriceList.tpl.html',
          size: 'md',
          controller: 'PriceListsDuplicateModalController',
          resolve: {
            priceLists: () => ctrl.model,
            currentPriceList: () => ctrl.currentPriceList,
          },
        })
        .result.then((name) => {
          ctrl.notice.hideSuccessMessages();
          ctrl.notice.hideErrorMessages();

          ctrl.duplicatePriceList = $.extend({}, ctrl.currentPriceList);
          ctrl.duplicatePriceList.name = name;

          ApiService.price.lists
            .create(ctrl.duplicatePriceList)
            .then((response) => ctrl.success.copy(response))
            .catch((response) => ctrl.error.copy(response));
        })
        .catch(() => {
          // noop
        });
    },

    create: function () {
      ctrl.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/lists/modals/createPriceList.tpl.html',
        size: 'lg',
        controller: 'PriceListsCreateModalController',
        resolve: {
          priceLists: () => ctrl.model,
        },
      });

      // Invoked when modal completes with close(params)
      ctrl.addModal.result
        .then((priceList) => {
          ctrl.notice.hideSuccessMessages();
          ctrl.notice.hideErrorMessages();

          ApiService.price.lists
            .create(priceList)
            .then((response) => ctrl.success.create(response))
            .catch((response) => ctrl.error.create(response));
        })
        .catch(() => {
          // noop
        });
    },

    remove: function () {
      ctrl.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/lists/modals/removePriceList.tpl.html',
        size: 'md',
        controller: 'PriceListsRemoveModalController',
        resolve: {
          currentPriceList: () => ctrl.currentPriceList,
        },
      });

      // Invoked when modal completes with close(params)
      ctrl.addModal.result
        .then(() => {
          ctrl.notice.hideSuccessMessages();
          ctrl.notice.hideErrorMessages();

          ctrl.isRemoving = true;

          ApiService.price.lists
            .remove(ctrl.currentPriceList.id)
            .then((response) => ctrl.success.remove(response))
            .catch((response) => ctrl.success.error(response));
        })
        .catch(() => {
          // noop
        });
    },

    update: function () {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      ctrl.isUpdating = true;
      ApiService.price.lists
        .update(ctrl.currentPriceList)
        .then((response) => {
          ctrl.tmpCurrentPriceList = angular.copy(ctrl.currentPriceList);
          ctrl.success.update(response);
        })
        .catch((response) => ctrl.error.update(response));
    },

    updateClose: function () {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      ctrl.isUpdating = true;
      ApiService.price.lists
        .update(ctrl.currentPriceList)
        .then((response) => {
          ctrl.tmpCurrentPriceList = angular.copy(ctrl.currentPriceList);

          if (ctrl.isEditing) {
            ctrl.toggleEdit();
          } else if (ctrl.isSorting) {
            ctrl.toggleReorder();
          }
          ctrl.success.update(response);
        })
        .catch((response) => ctrl.error.update(response));
    },

    removePrice: function (row) {
      let index = -1;

      for (let i = 0, ii = ctrl.currentPriceList.prices.length; i < ii; i++) {
        if (ctrl.currentPriceList.prices[i].personType.id === row.entity.personType.id) {
          index = i;
          break;
        }
      }

      if (index > -1) {
        ctrl.currentPriceList.prices.splice(index, 1);
      }
    },

    hasPrices: function () {
      return ctrl.currentPriceList.prices.length > 0;
    },

    getSelectedPriceList: function () {
      let r = 0;

      for (let i = 0, ii = ctrl.model.length; i < ii; i++) {
        if (ctrl.model[i].id === ctrl.selectedPriceListId) {
          r = i;
          break;
        }
      }

      return r;
    },

    getPriceLists: function () {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      ApiService.price.lists
        .list(HelpersService.getPaginator({ sortField: 'name', sortDirection: 'asc' }))
        .then((response) => ctrl.success.getPriceLists(response))
        .catch((response) => ctrl.error.getPriceLists(response));
    },

    getPriceList: function (id) {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();
      if (id) {
        ApiService.price.lists
          .detail(id)
          .then((response) => ctrl.success.getPriceList(response))
          .catch((response) => ctrl.error.getPriceList(response));
      }
    },

    moveUp: function (row) {
      const currentItem = angular.copy(row.entity);
      const idx = ctrl.currentPriceList.prices.indexOf(row.entity);
      const nextItem = angular.copy(ctrl.currentPriceList.prices[idx - 1]);

      if (idx > 0) {
        ctrl.reorderPriceList(idx, idx - 1, currentItem, nextItem);
      }
    },

    moveDown: function (row) {
      const currentItem = angular.copy(row.entity);
      const idx = ctrl.currentPriceList.prices.indexOf(row.entity);
      const nextItem = angular.copy(ctrl.currentPriceList.prices[idx + 1]);

      if (nextItem) {
        ctrl.reorderPriceList(idx, idx + 1, currentItem, nextItem);
      }
    },

    reorderPriceList: function (current, next, currentItem, nextItem) {
      ctrl.currentPriceList.prices[next] = currentItem;
      ctrl.currentPriceList.prices[current] = nextItem;
      ctrl.currentPriceList.prices.forEach((val, idx) => {
        val.displayOrder = idx + 1;
      });
    },

    onDisplayOrderChanged: function (item, col, newValue, oldValue) {
      if (newValue !== undefined && oldValue !== undefined) {
        if (newValue > ctrl.currentPriceList.prices.length) {
          newValue = ctrl.currentPriceList.prices.length;
        }
        const prices = ctrl.currentPriceList.prices.sort((a, b) => {
          let r = 0;

          if (a.displayOrder < b.displayOrder) {
            r = -1;
          } else {
            r = 1;
          }

          return r;
        });

        for (let i = 0, ii = prices.length; i < ii; i++) {
          prices[i].displayOrder = i + 1;
        }

        ctrl.currentPriceList.prices = prices;
      }
    },

    updateSalesChannels: function (channels) {
      const salesChannels: TODO[] = [];

      for (let i = 0, ii = channels.length; i < ii; i++) {
        for (let j = 0, jj = ctrl.salesChannels.length; j < jj; j++) {
          if (channels[i].channel === ctrl.salesChannels[j].channel) {
            salesChannels.push(angular.copy(channels[i]));
            break;
          }
        }
      }

      return salesChannels;
    },

    process: function (lists) {
      for (let i = 0, ii = lists.length; i < ii; i++) {
        lists[i] = ctrl.processList(lists[i]);
      }

      return lists;
    },

    processList: function (list) {
      for (let i = 0, ii = list.prices.length; i < ii; i++) {
        if (!list.prices[i].salesChannels) {
          list.prices[i].salesChannels = angular.copy(ctrl.salesChannels);
        } else if (
          list.prices[i].salesChannels instanceof Array &&
          list.prices[i].salesChannels.length !== ctrl.salesChannels.length
        ) {
          list.prices[i].salesChannels = ctrl.updateSalesChannels(list.prices[i].salesChannels);
        }
        list.prices[i].salesChannels = TemplatesService.orderSalesChannels(list.prices[i].salesChannels);
      }

      return list;
    },

    success: {
      create: function (response) {
        ctrl.model.push(response.data.payload);
        ctrl.onSelectList({}, { id: response.data.payload.id });

        $scope.$emit('PricingListsController::priceListsUpdate', {
          selectedPriceListId: response.data.payload.id,
          model: ctrl.model,
        });

        ctrl.notice.showSuccessMessages([{ message: 'Successfully Created!' }], { duration: 3000 });
      },

      copy: function (response) {
        ctrl.model.push(response.data.payload);
        ctrl.onSelectList({}, { id: response.data.payload.id });

        $scope.$emit('PricingListsController::priceListsUpdate', {
          selectedPriceListId: response.data.payload.id,
          model: ctrl.model,
        });

        ctrl.notice.showSuccessMessages([{ message: 'Successfully Duplicated!' }], { duration: 3000 });
      },

      remove: function (response) {
        ctrl.isRemoving = false;
        ctrl.model.splice(ctrl.currentPriceListIndex, 1);
        ctrl.onSelectList({}, { id: ctrl.model[0].id });

        $scope.$emit('PricingListsController::priceListsUpdate', {
          selectedPriceListId: ctrl.model[0].id,
          model: ctrl.model,
        });
      },

      update: function (response) {
        ctrl.isUpdating = false;

        ctrl.notice.showSuccessMessages([{ message: 'Successfully Updated!' }], { duration: 3000 });
      },

      getPriceLists: function (response) {
        ctrl.model = ctrl.process(response.data.payload.list);
        ctrl.currentPriceListIndex = ctrl.getSelectedPriceList();
        ctrl.currentPriceList = ctrl.model[ctrl.currentPriceListIndex];
        ctrl.isLoaded = true;

        if (ctrl.currentPriceList) {
          $scope.$emit('PricingListsController::priceListsUpdate', {
            selectedPriceListId: ctrl.currentPriceList.id,
            model: ctrl.model,
          });
        }

        $scope.$emit('AppController::endLoad');
      },

      getPriceList: function (response) {
        ctrl.model = [ctrl.processList(response.data.payload)];
        ctrl.currentPriceListIndex = 0;
        ctrl.currentPriceList = ctrl.model[0];
        ctrl.isLoaded = true;
        if (ctrl.currentPriceList) {
          $scope.$emit('PricingListsController::priceListUpdate', {
            selectedPriceListId: ctrl.currentPriceList.id,
            model: ctrl.model,
          });
        }
      },
    },

    error: {
      create: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },

      copy: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },

      remove: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },

      update: function (response) {
        ctrl.isUpdating = false;
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },

      getPriceLists: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },

      getPriceList: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },
    },

    onSelectList: function (e, data) {
      ctrl.selectedPriceListId = data.id;
      ctrl.currentPriceListIndex = ctrl.getSelectedPriceList();
      ctrl.currentPriceList = ctrl.model[ctrl.currentPriceListIndex];
      ctrl.tmpCurrentPriceList = angular.copy(ctrl.currentPriceList);

      ctrl.currentPriceList = ctrl.model[ctrl.currentPriceListIndex];
    },

    onAddPrice: function (e, data: { price: CurrentPrice }) {
      ctrl.notice.hideErrorMessages();

      const found = ctrl.currentPriceList.prices.find((price) => price.personType.id === data.price.personType.id);

      if (found) {
        const message = `Ticket type ${data.price.personType.name} is already added. Please double click below to edit it.`;
        ctrl.notice.showErrorMessages([{ message }]);
      } else {
        ctrl.currentPriceList.prices.push(data.price);
      }
    },

    onGridEventChangeOrder: function (e, data) {
      if (data && data.from !== undefined && data.to !== undefined) {
        for (let i = 0, ii = ctrl.currentPriceList.prices.length; i < ii; i++) {
          ctrl.currentPriceList.prices[i].displayOrder = i + 1;
        }
      }
    },
  };

  $scope.pricingLists = ctrl;
  ctrl.init();
}

export const PricingListsControllerModule = angular
  .module('acme.view.application.pricing.lists.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.validate',
    'acme.common.service.templates',
    'acme.common.service.themesHelper',
    'acme.common.factory.notice',
    PriceListsCreateModalControllerModule,
    PriceListsRemoveModalControllerModule,
    PriceListsDuplicateModalControllerModule,
    PricingListsEditControllerModule,
    NoticesComponentModule,
    BasePriceFilterModule,
  ])
  .controller('PricingListsController', PricingListsController).name;

function createSaleChannelColumnTemplate() {
  return `
    <div class="ui-grid-cell-contents"
          data-ng-class="col.colIndex()">
      <input type="checkbox"
            class="grid-input"
            data-ng-if="grid.appScope.isEditing()"
            data-ng-model="MODEL_COL_FIELD" />

      <div data-ng-if="!grid.appScope.isEditing()">
        <span data-ng-if="COL_FIELD">Yes</span>
        <span data-ng-if="!COL_FIELD">No</span>
      </div>
    </div>
  `;
}
